import {
  GET_AUTOMATION_FLOWS_BEGIN,
  GET_AUTOMATION_FLOWS_SUCCESS,
  GET_AUTOMATION_FLOWS_FAIL,

  CREATE_AUTOMATION_FLOW_BEGIN,
  CREATE_AUTOMATION_FLOW_SUCCESS,
  CREATE_AUTOMATION_FLOW_FAIL,

  UPDATE_AUTOMATION_FLOW_BEGIN,
  UPDATE_AUTOMATION_FLOW_SUCCESS,
  UPDATE_AUTOMATION_FLOW_FAIL,

  DELETE_AUTOMATION_FLOW_BEGIN,
  DELETE_AUTOMATION_FLOW_SUCCESS,
  DELETE_AUTOMATION_FLOW_FAIL,

  GET_AUTOMATION_LOGS_BEGIN,
  GET_AUTOMATION_LOGS_SUCCESS,
  GET_AUTOMATION_LOGS_FAIL,
} from '../actions/types';

const initialState = {
  automations: {},
  logs: [],
  pagination: [],
  errors: [],
  success: [],
  loading: false,
};

const automation = (state = initialState, action) => {
  switch (action.type) {
    case GET_AUTOMATION_FLOWS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case CREATE_AUTOMATION_FLOW_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_AUTOMATION_FLOW_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_AUTOMATION_FLOW_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_AUTOMATION_LOGS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_AUTOMATION_FLOWS_SUCCESS:
      return {
        ...state,
        automations: action.payload.data,
        loading: false,
      };
    case GET_AUTOMATION_FLOWS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case CREATE_AUTOMATION_FLOW_SUCCESS:
      return {
        ...state,
        success: { success: [action.payload.message || action.payload.data.message || 'Automation Created Successfully'] },
        fees: action.payload.data,
        volume30: action.payload.volume30,
        loading: false,
      };
    case CREATE_AUTOMATION_FLOW_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case UPDATE_AUTOMATION_FLOW_SUCCESS:
      return {
        ...state,
        success: { success: [action.payload.message || action.payload.data.message || 'Automation Updated Successfully'] },
        loading: false,
      };
    case UPDATE_AUTOMATION_FLOW_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case DELETE_AUTOMATION_FLOW_SUCCESS:
      return {
        ...state,
        success: { success: [action.payload.message || action.payload.data.message || 'Automation Deleted Successfully'] },
        loading: false,
      };
    case DELETE_AUTOMATION_FLOW_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case GET_AUTOMATION_LOGS_SUCCESS:
      return {
        ...state,
        logs: action.payload.data,
        pagination: action.payload.pagination || [''],
        loading: false,
      };
    case GET_AUTOMATION_LOGS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    default:
      return state;
  }
};

export default automation;
